import { render, staticRenderFns } from "./PICK_features_module.vue?vue&type=template&id=2319d2ea&"
import script from "./PICK_features_module.vue?vue&type=script&lang=js&"
export * from "./PICK_features_module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports